import { createGlobalStyle } from 'styled-components';

import MuseoSansCyrl700Eot from 'assets/fonts/MuseoSansCyrl-700.eot';
import MuseoSansCyrl700Woff from 'assets/fonts/MuseoSansCyrl-700.woff';
import MuseoSansCyrl700Ttf from 'assets/fonts/MuseoSansCyrl-700.ttf';

import MuseoSansCyrl500Eot from 'assets/fonts/MuseoSansCyrl-500.eot';
import MuseoSansCyrl500Woff from 'assets/fonts/MuseoSansCyrl-500.woff';
import MuseoSansCyrl500Ttf from 'assets/fonts/MuseoSansCyrl-500.ttf';

const FontStyles = createGlobalStyle`
  @font-face {
    font-family: 'Museo Sans Cyrl';
    src: url('${MuseoSansCyrl700Eot}');
    src: local('MuseoSansCyrl-700'),
      url('${MuseoSansCyrl700Eot}?#iefix') format('embedded-opentype'),
      url('${MuseoSansCyrl700Woff}') format('woff'),
      url('${MuseoSansCyrl700Ttf}') format('truetype');
  }

  @font-face {
    font-family: 'Museo Sans Cyrl';
    src: url('${MuseoSansCyrl500Eot}');
    src: local('MuseoSansCyrl-500'),
      url('${MuseoSansCyrl500Eot}?#iefix') format('embedded-opentype'),
      url('${MuseoSansCyrl500Woff}') format('woff'),
      url('${MuseoSansCyrl500Ttf}') format('truetype');
  }

  @font-face {
    font-family: 'Museo Sans Cyrl';
    src: url('${MuseoSansCyrl500Eot}');
    src: local('MuseoSansCyrl-500'),
      url('${MuseoSansCyrl500Eot}?#iefix') format('embedded-opentype'),
      url('${MuseoSansCyrl500Woff}') format('woff'),
      url('${MuseoSansCyrl500Ttf}') format('truetype');
    font-weight: 400;
    font-style: normal;
    text-decoration-line: underline;
  }
`;

export default FontStyles;
